if (!customElements.get('snx-card-media')) {
  customElements.define('snx-card-media', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.card = this.closest('.yv-product-card-img') || this;
      this.activate = () => this.loadContent();
      this.card.addEventListener('pointerenter', this.activate);
      this.card.addEventListener('focusin', this.activate, true);
      this.card.addEventListener('click', this.activate, true);
      if (!('IntersectionObserver' in window)) {
        this.loadContent();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.loadContent();
          else this.pause();
        });
      }, { rootMargin: '0px', threshold: 0 });
      this.observer.observe(this.card);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.card?.removeEventListener('pointerenter', this.activate);
      this.card?.removeEventListener('focusin', this.activate, true);
      this.card?.removeEventListener('click', this.activate, true);
      this.pause();
    }

    loadContent() {
      const template = this.querySelector('template');
      if (template) {
        this.appendChild(template.content.cloneNode(true));
        template.remove();
        this.querySelector('[data-snx-card-poster]')?.remove();
        const slider = this.closest('[data-flickity-slider], [data-flickity-hover-slider]');
        if (slider && window.Flickity) window.Flickity.data(slider)?.resize();
      }
      this.querySelectorAll('video[autoplay]').forEach((video) => {
        const playing = video.play();
        if (playing) playing.catch(() => {});
      });
    }

    pause() {
      this.querySelectorAll('video').forEach((video) => video.pause());
    }
  });
}
